import Vue from 'vue'
import Router from 'vue-router'
const IndexPage = () => import('@/views/pages/Index')
const ArticlePage = () => import('@/views/pages/Article')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: IndexPage,
      meta: {
        title: 'Message Studio',
        layout: 'default'
      }
    },
    {
      path: '/article/:id/:slug',
      name: 'article',
      component: ArticlePage,
      meta: {
        title: '',
        layout: 'default'
      }
    }
  ]
})
